import { render, staticRenderFns } from "./dialogRoleListPerson.vue?vue&type=template&id=0c697554&scoped=true"
import script from "./dialogRoleListPerson.vue?vue&type=script&lang=js"
export * from "./dialogRoleListPerson.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleListPerson.vue?vue&type=style&index=0&id=0c697554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c697554",
  null
  
)

export default component.exports